import { ShapeType, BShape } from './BShape';
import { NumPair } from '../../Misc/Utils';
import { ObjectType } from '../ObjectTypeEnum';

export class BCircle extends BShape{

    protected readonly TYPE = ObjectType.CIRCLE;
    
    constructor(centre: NumPair, radius: number, frameRange : NumPair){
        super(centre, ShapeType.CIRCLE, frameRange);
        this.uniformScaling = true;
        this.setWH([2*radius,2*radius]);
    }

    protected drawShape(canvasCtx : CanvasRenderingContext2D): void{
        var path2d = new Path2D();
        var rad = this.getRadius();
        path2d.arc(0, 0, rad, 0, 2*Math.PI);
        canvasCtx.fill(path2d);
        canvasCtx.stroke(path2d);
    }

    public getRadius(): number{
        if(this.wh[0]<0){
            return -this.wh[0]/2;
        }
        return this.wh[0]/2;
    }

    public clone() : BCircle{
        var dupObj : BCircle = new BCircle(this.getCentre(), this.getWH()[0], this.getFrameRange());
        super.duplicate(dupObj);
        return dupObj;
    }

}